export default __webpack_public_path__ + "static/media/c3.9ff800cd.svg";